import { Injectable, inject } from "@angular/core";
import { ApiWrapperService } from "ngx-apiwrapper";
import { HATEOAS } from "./models/hateoas.model";

@Injectable({
  providedIn: 'root'
})
export class OrganiserService {
  private readonly _apiWrapper = inject(ApiWrapperService);

  onboardPaypalMerchant(organiserID:number, email:string){
    return this._apiWrapper.post<HATEOAS[]>(`payments/paypal/onboard-merchant`, { organiserID, email})
  }
}